import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { SelectionToggler } from '../../../components/Selection/Toggler';
import { ResolutionDisplayType } from '../../../utils/driveItem';
import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { SelectionType } from '../actions';

interface SelectionTogglerOwnProps {
	itemId: number;
	displayMode: ResolutionDisplayType;
	needBottomPadding?: boolean;
	selectionType?: SelectionType;
}

const mapStateToProps = (state: StoreState, ownProps: SelectionTogglerOwnProps) => {
	const { selection, galleryInfos } = state;
	const { itemId, displayMode, selectionType = SelectionType.RESOURCES } = ownProps;
	const primary = galleryInfos.template.commonStyles && galleryInfos.template.commonStyles.primary;
	const isInSelection = selection[selectionType].includes(itemId);

	let color: string;
	switch (displayMode) {
		case ResolutionDisplayType.Detail:
			color = primary ? primary.iconsColor : StyleColor.White;
			break;
		case ResolutionDisplayType.Card:
		case ResolutionDisplayType.Theater:
		default:
			color = isInSelection ? NewStyleColor.Yellow : StyleColor.White;
			break;
	}

	return { color, isInSelection };
};

export default connect(mapStateToProps)(SelectionToggler);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Selection/Toggler/index.tsx